export const AUTH_TOKEN = 'AUTH_TOKEN'
export const ADMIN_AUTH_TOKEN = 'ADMIN_AUTH_TOKEN'

/**
 * Appstream supported
 */
export const AWS_REGIONS = [
  { name: 'Ohio', code: 'us-east-2' },
  { name: 'N. Virginia', code: 'us-east-1' },
  // { name: 'N. California', code: 'us-west-1' },
  { name: 'Oregon', code: 'us-west-2' },
  // { name: 'Cape Town', code: 'af-south-1' },
  // { name: 'Hong Kong', code: 'ap-east-1' },
  // { name: 'Jakarta', code: 'ap-southeast-3' },
  { name: 'Mumbai', code: 'ap-south-1' },
  // { name: 'Osaka', code: 'ap-northeast-3' },
  { name: 'Seoul', code: 'ap-northeast-2' },
  { name: 'Singapore', code: 'ap-southeast-1' },
  { name: 'Sydney', code: 'ap-southeast-2' },
  { name: 'Tokyo', code: 'ap-northeast-1' },
  { name: 'Canada', code: 'ca-central-1' },
  { name: 'Frankfurt', code: 'eu-central-1' },
  { name: 'Ireland', code: 'eu-west-1' },
  { name: 'London', code: 'eu-west-2' },
  // { name: 'Milan', code: 'eu-south-1' },
  // { name: 'Paris', code: 'eu-west-3' },
  // { name: 'Stockholm', code: 'eu-north-1' },
  // { name: 'Bahrain', code: 'me-south-1' },
  { name: 'Sao Paulo', code: 'sa-east-1' }
].sort((a, b) => (a.name > b.name ? 1 : -1))

const AWS_REGIONS_MAP = AWS_REGIONS.reduce(
  (pre, cur) => ({ ...pre, [cur.code]: cur.name }),
  {}
)

export function regionCodeToName(code) {
  return AWS_REGIONS_MAP[code] ?? ''
}

export const SOFTWARES_VERSIONS = ['12.1.14', '15.0.5']

export const JOIN_TYPE_HANDS_ON = 'hands-on'
export const JOIN_TYPE_VIEWER = 'viewer'
export const JOIN_TYPE_RECORDING = 'recording'
